import { create } from 'zustand';

// Sidebar visibility. Desktop: collapsed hides the sidebar (remembered).
// Phone (≤900px): the sidebar is an overlay that is closed by default.
const KEY = 'sd-sidebar-collapsed';

function readCollapsed(): boolean {
  try { return localStorage.getItem(KEY) === '1'; } catch { return false; }
}

interface NavState {
  collapsed:  boolean;   // desktop
  mobileOpen: boolean;   // phone overlay
  toggle:     () => void;
  closeMobile: () => void;
}

export const isPhoneWidth = () => typeof window !== 'undefined' && window.matchMedia('(max-width: 900px)').matches;

export const useNavStore = create<NavState>((set, get) => ({
  collapsed:  readCollapsed(),
  mobileOpen: false,
  toggle: () => {
    if (isPhoneWidth()) { set({ mobileOpen: !get().mobileOpen }); return; }
    const collapsed = !get().collapsed;
    try { localStorage.setItem(KEY, collapsed ? '1' : '0'); } catch { /* storage blocked */ }
    set({ collapsed });
  },
  closeMobile: () => set({ mobileOpen: false }),
}));
